import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { RegistrationService } from '../../services/registration.service';

@Component({
  selector: 'restore-component',
  templateUrl: './restore.component.html',
  providers: [],
})
export class RestoreComponent implements OnInit {
  username = '';
  email = '';
  errors = [];

  processing = false;

  constructor(
    private router: Router,
    private registrationService: RegistrationService,
    private authService: AuthenticationService
  ) {  }

  ngOnInit() {}

  restore() {
    this.processing = true;
    this.registrationService
      .restorePassword({
        username: this.username,
        email: this.email
      })
      .subscribe(
        (response) => {
          console.log('restore response:', response);
          this.processing = false;
          if (response.status == 'success') {
            alert("Password reset. Please check your email for the new password.");
            this.router.navigate(['signin']);
          } else {
            this.errors = response.errors;
            if (this.errors === undefined) {
              this.errors = ['Unknown error, please try again later.'];
            }
          }
        },
        (err) => {
          console.log(err);
          this.processing = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/signup/restore.component.ts